import React, { createContext, useContext, useEffect, useState } from 'react';
import api from './api';

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (window.location.hash && window.location.hash.includes('session_id=')) { setLoading(false); return; }
    const t = localStorage.getItem('ea_token');
    if (!t) { setLoading(false); return; }
    api.get('/auth/me')
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem('ea_token'))
      .finally(() => setLoading(false));
  }, []);

  const persist = (data) => {
    localStorage.setItem('ea_token', data.token);
    setUser(data.user);
    return data.user;
  };

  const login = async (email, password) => persist((await api.post('/auth/login', { email, password })).data);
  const register = async (payload) => persist((await api.post('/auth/register', payload)).data);
  const googleSession = async (sessionId) => {
    const { data } = await api.post('/auth/google-session', { session_id: sessionId });
    localStorage.setItem('ea_token', data.token);
    setUser(data.user);
    return data;
  };
  const setRole = async (role) => { const r = await api.post('/auth/set-role', { role }); setUser(r.data); return r.data; };
  const logout = () => { localStorage.removeItem('ea_token'); setUser(null); };
  const refresh = async () => { try { const r = await api.get('/auth/me'); setUser(r.data); } catch (e) {} };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, googleSession, setRole, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
};
